import { ComponentProps, FC } from "react";
import { FormattedMessage as LibFormattedMessage } from "react-intl";

import { LocaleKeys } from "src/internationalization/CustomIntlProvider";

export type FormattedMessageProps = Omit<ComponentProps<typeof LibFormattedMessage>, "id"> & {
  id: LocaleKeys;
};

export const FormattedMessage: FC<FormattedMessageProps> = ({ values, ...props }) => {
  return (
    <LibFormattedMessage
      values={{
        bold: (chunks) => <span className="font-bold">{chunks}</span>,
        i: (chunks) => <span className="italic">{chunks}</span>,
        focus: (chunks) => <span className="text-textHighlight">{chunks}</span>,
        semibold: (chunks) => <span className="font-semibold">{chunks}</span>,
        ...values,
      }}
      {...props}
    />
  );
};
